document.addEventListener('DOMContentLoaded', () => {
    const STORAGE_KEY = 'uswds_accordion_state';
    const cachedStates = JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}');

    document.querySelectorAll('button[data-accordion-cache]').forEach(button => {
        const panelId = button.getAttribute('aria-controls');
        if (!panelId) return;

        const panel = document.getElementById(panelId);

        // Restore cached state prior to USWDS interaction
        if (cachedStates[panelId] !== undefined) {
            const isOpen = cachedStates[panelId] === 'true';
            button.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
            if (panel) {
                panel.hidden = !isOpen;
            }
        }

        // Cache new state on toggle
        button.addEventListener('click', () => {
            setTimeout(() => {
                const currentState = button.getAttribute('aria-expanded');
                const latestStorage = JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}');
                latestStorage[panelId] = currentState;
                localStorage.setItem(STORAGE_KEY, JSON.stringify(latestStorage));
            }, 0);
        });
    });
});